import React from 'react';
import './InitialMuteModal.css';
import { getUILoc } from '../../utils/cardUtils.js';

const InitialMuteModal = ({ isOpen, onSelect }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="initial-modal-overlay">
      <div className="initial-modal-content">
        <div className="initial-modal-header">
          <h3>{getUILoc('INITIAL_MUTE.TITLE')}</h3>
        </div>
        <div className="initial-modal-body">
          <p>{getUILoc('INITIAL_MUTE.MESSAGE')}</p>
        </div>
        <div className="initial-modal-footer">
          <button 
            className="initial-modal-button enable-button"
            onClick={() => onSelect(false)}
          >
            {getUILoc('INITIAL_MUTE.ENABLE')}
          </button>
          <button 
            className="initial-modal-button mute-button"
            onClick={() => onSelect(true)}
          >
            {getUILoc('INITIAL_MUTE.MUTE')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InitialMuteModal;
